import { DateTime } from "luxon";
import i18n from "./lib/i18n";

/**
 * Formats a date into a string.
 * @param date - The date to format.
 * @returns The formatted date.
 */
const formatDate = (date: string | DateTime): string => {
	if (!date) {
		return "";
	}
	const dateTime =
		typeof date === "string"
			? DateTime.fromISO(date).setLocale(i18n.language)
			: date;
	return dateTime.toFormat("MMMM d, yyyy");
};

const formatTimeString = (time: string, timeStamp?: boolean, useUTC = true) => {
	const date = new Date(time);
	const options: Intl.DateTimeFormatOptions = {
		year: "numeric",
		month: "long",
		day: "numeric",
		...(timeStamp
			? {
					hour: "numeric",
					minute: "numeric",
					...(useUTC ? { timeZone: "UTC" } : {}),
					hour12: true,
				}
			: {}),
	};

	const formattedDate = date.toLocaleString("en-US", options);
	return formattedDate;
};

const formatExamDate = (examDate: string): string => {
	const dateTime = DateTime.fromISO(examDate);
	return dateTime.isValid ? dateTime.toFormat("MMMM dd, yyyy") : examDate;
};

const formatDateToLocalizedString = (date: string) =>
	DateTime.fromFormat(date, "MMMM d, yyyy", { locale: "en-US" })
		.setLocale(i18n.language)
		.toLocaleString(DateTime.DATE_FULL);

export {
	formatDate,
	formatTimeString,
	formatExamDate,
	formatDateToLocalizedString,
};
